import React from "react";
import {useSelector} from "react-redux";
import {RootState} from "../../models";

function BaseDataDisplay(props: { name: string, value: string }) {
    const state: any = useSelector<RootState>(root => root.baseData)
    return state[props.name]?.find((item: any) => item.key === props.value)?.value
}

export default BaseDataDisplay
